import 

<template>
    <div id="app">
        <router-view></router-view>
    </div>
</template>

<script>
export default {
    name: 'app',
    data: function () {
        return {
        };
    }
};
</script>

<style>
html, body {
    overflow-y: hidden!important;
}
#app {
    position: absolute;
    width: 100%;
    height: 100%;

}
</style>



// WEBPACK FOOTER //
// App.vue?88c952f8